import React from 'react';
import { CheckIcon } from 'lucide-react';
const ServiceCard = ({
  title,
  price,
  description,
  features,
  primary = false,
  gradientClass = 'gradient-card-dark',
  ctaText = 'Book a Consultation',
  ctaLink = 'http://calendly.com/es-lee'
}) => {
  return <div className={`${gradientClass} border border-zinc-200 p-8 rounded-sm relative overflow-hidden h-full`} data-id="element-142">
      <div className="relative z-10" data-id="element-143">
        <h3 className="font-serif text-2xl mb-2 text-zinc-900" data-id="element-144">{title}</h3>
        <div className="text-zinc-600 mb-6" data-id="element-145">{description}</div>
        <div className="mb-8" data-id="element-146">
          <div className="font-serif text-3xl mb-1 text-zinc-900" data-id="element-147">{price}</div>
        </div>
        <ul className="space-y-3 mb-8" data-id="element-148">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-149">
              <CheckIcon size={18} className="mr-2 mt-1 flex-shrink-0 text-teal-dark" data-id="element-150" />
              <span className="text-zinc-700" data-id="element-151">{feature}</span>
            </li>)}
        </ul>
        <a href={ctaLink} target="_blank" rel="noopener noreferrer" className={`block text-center px-6 py-3 rounded-sm transition-colors ${primary ? 'bg-zinc-800 text-white hover:bg-zinc-700' : 'border border-zinc-300 hover:bg-zinc-100 text-zinc-800'}`} data-id="element-152">
          {ctaText}
        </a>
      </div>
    </div>;
};
export const Services = () => {
  return <section id="services" className="py-24 bg-white text-zinc-800 relative" data-id="element-153">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(59,166,159,0.1),transparent_70%)]" data-id="element-154"></div>
      <div className="container-custom relative z-10" data-id="element-155">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-156">
          <h2 className="font-serif text-4xl mb-6 text-zinc-900" data-id="element-157">
            From AI Concept To{' '}
            <span className="accent-text" data-id="element-158">A Working Product</span>
          </h2>
          <p className="text-zinc-600" data-id="element-159">
            Whether you want to experiment with AI, integrate it into your
            workflow, or create a new product altogether, we rapidly put your AI
            use case into production as a done-for-you expert service.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-160">
          <ServiceCard title="Consulting Package" price="$10,000" description="20-hour consulting bundles consumed within a month" gradientClass="gradient-card-medium" features={['Scoping & integration analysis', 'Integration deployment', 'Basic AI deployment', 'Remediation for existing AI builds', 'Technical feasibility assessment', 'Recommendations for future development']} data-id="element-161" />
          <ServiceCard title="Build Package" price="$100,000 minimum" description="Our core offering - a complete AI product development playbook" primary={true} gradientClass="gradient-card-dark" features={['Custom AI that performs the function', 'App development ready for users', 'Technical infrastructure for scaling', 'Brand creation', 'Business setup guidance', 'Website storefront development', 'Digital presence setup', '$5,000/month ongoing support']} data-id="element-162" />
          <ServiceCard title="DIY AI Agent" price="$500/month" description="Self-service AI agent with dedicated support" gradientClass="gradient-card-medium" features={['250 AI conversations/month', '$2/conversation overage', 'Answers inbound calls & SMS texts', 'Embedded chat widget for websites', 'DIY platform setup assistance', 'Integration support as needed', 'Dedicated phone number']} ctaText="Get Started" ctaLink="https://bots.messagesimproved.com" data-id="element-163" />
        </div>
        <div className="mt-12 text-center text-zinc-500" data-id="element-164">
          <p data-id="element-165">
            Compare to OpenAI Consulting at{' '}
            <span className="line-through" data-id="element-166">$10 million minimum</span>
          </p>
        </div>
      </div>
    </section>;
};